import { render, staticRenderFns } from "./AlbumDetail.vue?vue&type=template&id=ef8c94fc&"
import script from "./AlbumDetail.vue?vue&type=script&lang=js&"
export * from "./AlbumDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlbumDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports